import { render, staticRenderFns } from "./EmailAuth.vue?vue&type=template&id=0077235a&"
import script from "./EmailAuth.vue?vue&type=script&lang=ts&"
export * from "./EmailAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports